<template>
  <div id="article-container">
    <article-navigation-bar />
    <article-page/>
    <article-menu/>
  <!-- v-show="showArticles" -->
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import ArticleNavigationBar from './ArticleNavigationBar.vue'
import ArticleMenu from './ArticleMenu.vue'
import ArticlePage from './ArticlePage.vue'
import FeatherIcon from "./FeatherIcon.vue"


export default {
  components: {
    ArticleNavigationBar,
    ArticleMenu,
    ArticlePage,
    FeatherIcon,
  },
  computed: {
    ...mapGetters([
      "currentArticle",
      "nextArticle",
      "previousArticle",
      // "showArticles"
    ]),
    options() {
      return {
        width: 25,
        height: 25,
      }
    },
  }
}
</script>

<style>

#article-container {
  font-size: 1em;
}

</style>


// WEBPACK FOOTER //
// src/components/ArticleContainer.vue